__turbopack_context__.v({
  "preview_color": "rkDBaW_preview_color",
  "preview_color_border": "rkDBaW_preview_color_border",
  "preview_color_graphic": "rkDBaW_preview_color_graphic",
  "preview_color_surface": "rkDBaW_preview_color_surface",
  "preview_color_text": "rkDBaW_preview_color_text",
  "preview_elevation": "rkDBaW_preview_elevation",
  "preview_radius": "rkDBaW_preview_radius",
  "preview_spacing": "rkDBaW_preview_spacing",
  "wrapper": "rkDBaW_wrapper",
  "wrapper_sentiment": "rkDBaW_wrapper_sentiment",
});
